/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Share_XInputs */

const en_directory_submit_enrich_share_x = /** @type {(inputs: Directory_Submit_Enrich_Share_XInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share on X`)
};

const zh_directory_submit_enrich_share_x = /** @type {(inputs: Directory_Submit_Enrich_Share_XInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享到 X`)
};

/**
* | output |
* | --- |
* | "Share on X" |
*
* @param {Directory_Submit_Enrich_Share_XInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_share_x = /** @type {((inputs?: Directory_Submit_Enrich_Share_XInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Share_XInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_share_x(inputs)
	return zh_directory_submit_enrich_share_x(inputs)
});
export { directory_submit_enrich_share_x as "directory.submit.enrich.share_x" }